import axios from "axios";
import { API } from "../shared/api/Api";

const handleMarkOffline = async (user) => {
  await axios.post(
    `${API.Activity.app_activity_markOffLine}/${user.uuid}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${user?.token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const Logout = async (user) => {
  try {
    const { data } = await axios.post(
      API.Admin.logout,
      {},
      {
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Accept: "application/json",
          lang: "en",
        },
      }
    );

    if (data) {
      handleMarkOffline(user);
    }

    return data;
  } catch (error) {
    return {
      status: error?.response?.status || 500,
      errorCode: 1,
      message:
        error?.response?.data?.message || "An unexpected error occurred.",
    };
  }
};
